import { ChangeDetectionStrategy, Component, inject } from '@angular/core'
import { ActivatedRoute } from '@angular/router'
import { ElderShellService } from '@elderbyte/ngx-starter'
import { PackageType } from '../package-type'
import { PackageTypeDetailComponent } from '../package-type-detail/package-type-detail.component'

@Component({
  selector: 'app-package-type-detail-side',
  templateUrl: './package-type-detail-side.component.html',
  styleUrls: ['./package-type-detail-side.component.scss'],
  imports: [PackageTypeDetailComponent],
})
export class PackageTypeDetailSideComponent {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  public packageType: PackageType | undefined
  private shellService = inject(ElderShellService)

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    const route = inject(ActivatedRoute)
    this.packageType = route.snapshot.data['type']
  }

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  public onClose(event: Event): void {
    this.shellService.closeSideContent()
  }
}
